module.exports = __webpack_public_path__ + "static/media/chemistry.e9a3a379.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/chemistry.svg
// module id = 130
// module chunks = 0